import template from './form.html';
import clienteTemplate from './cliente.html';
import nuevoClienteTemplate from './cliente.nuevo.html';
import productoTemplate from './producto.html';
import paquetesTemplate from './paquetes.html';
import giftcardTemplate from './giftcard.html';
import { FormActions } from 'core/services/form';
import { rest } from 'core/api';
import facturasI18N from 'i18n/facturas/es.json';
import commonI18N from 'i18n/common/es.json';
import { pad, fechaRenderer } from 'core/util';
import { formatErrorMessage } from 'core/util';

import config from 'config.json';
import { download } from '../../../core/util';

export let FacturaFormComponent = {
  templateUrl: template,
  selector: 'facturaForm',
  bindings: {
    view: '<',
    translations: '='
  },
  controller: FormController,
  controllerAs: 'vm'
};

export const translationKeys = Object.keys(facturasI18N).concat(Object.keys(commonI18N));


FormController.$inject = [
  '$state', '$filter', '$ngRedux', 'ngNotify', '$stateParams', 'Filter', 'AuthorizationService', 'BasicFactory', '$timeout', 'localStorageService', 'CustomModal', '$scope', '$resource', 'HeadersUtil'
];

function FormController($state, $filter, $ngRedux, ngNotify, $stateParams, Filter, AuthorizationService, BasicFactory, $timeout, localStorageService, CustomModal, $scope, $resource, HeadersUtil) {
  this.handleStatus = handleStatus.bind(this);
  this.mapStateToThis = mapStateToThis.bind(this);
  this.doSubmit = doSubmit.bind(this);


  this.loadClientes = loadClientes.bind(this);
  this.loadProductos = loadProductos.bind(this);
  this.loadPaquetesNuevos = loadPaquetesNuevos.bind(this);
  this.loadPaquetesCliente = loadPaquetesCliente.bind(this);

  this.newDetalleCliente = newDetalleCliente.bind(this);
  this.newDetalleProductoModal = newDetalleProductoModal.bind(this);
  this.newDetallePaquete = newDetallePaquete.bind(this);
  this.newDetalleGiftcard = newDetalleGiftcard.bind(this);
  this.newDescuentoGiftcard = newDescuentoGiftcard.bind(this);
  this.newFormaPagoDescuento = newFormaPagoDescuento.bind(this);
  this.renderPaquete = renderPaquete.bind(this);
  this.newDetalleOrdenes = newDetalleOrdenes.bind(this);

  this.nuevoCliente = nuevoCliente.bind(this);

  this.deleteDetalleProducto = deleteDetalleProducto.bind(this);
  this.deleteDetalleOrden = deleteDetalleOrden.bind(this);
  this.deleteOrden = deleteOrden.bind(this);
  this.renderMontoOrden = renderMontoOrden.bind(this);
  this.renderDescripcionOrden = renderDescripcionOrden.bind(this);
  this.renderDescripcionProducto = renderDescripcionProducto.bind(this);

  this.renderCliente = renderCliente.bind(this);
  this.filterCliente = filterCliente.bind(this);
  this.renderTipoComprobante = renderTipoComprobante.bind(this);
  this.onSelectTipoComprobante = onSelectTipoComprobante.bind(this);
  this.renderProducto = renderProducto.bind(this);
  this.filterProducto = filterProducto.bind(this);
  this.cobrarFacturaNotify = cobrarFacturaNotify.bind(this);

  this.notEmpty = notEmpty.bind(this);
  this.setTotales = setTotales.bind(this);
  this.updateTotales = updateTotales.bind(this);
  this.buildDetalles = buildDetalles.bind(this);

  this.completeNumeroFactura = completeNumeroFactura.bind(this);

  this.onSelectFormaPago = onSelectFormaPago.bind(this);
  this.renderFormaPago = renderFormaPago.bind(this);


  this.buscar = buscar.bind(this);

  let unsubscribe;


  const sexoQuery = Filter.path('tipo.codigo').eq('sexo');
  const tipoPersonaQuery = Filter.path('tipo.codigo').eq('tipo_persona');
  const tipoDocumentoQuery = Filter.path('tipo.codigo').eq('tipo_documento');
  const estadosFactura = Filter.path('tipo.codigo').eq('estado_factura');

  const valoresFilter = sexoQuery.or(tipoDocumentoQuery).or(tipoPersonaQuery).or(estadosFactura);
  const sinNombreFilter = Filter.path('numeroDocumento').like('44444401-7');


  this.$onDestroy = () => {
    this.form();
    $ngRedux.dispatch(rest.actions.timbradosVigentes.reset());
    $ngRedux.dispatch(rest.actions.valores.reset());
    $ngRedux.dispatch(rest.actions.clientesOrdenesFinalizadas.reset());
    $ngRedux.dispatch(rest.actions.cotizacionVigente.reset());
    $ngRedux.dispatch(rest.actions.search.reset());
    unsubscribe();
  };

  this.$onInit = () => {
    this.hayTimbrados = true;
    this.canAgregarDescuentoServicio = AuthorizationService.hasPermission('descuento_factura_detalle_servicio');
    this.canAgregarDescuentoProducto = AuthorizationService.hasPermission('descuento_factura_detalle_producto');
    this.canModificarNumeroComprobante = AuthorizationService.hasPermission('update_numero_comprobante_nueva_factura');
    unsubscribe = $ngRedux.connect(this.mapStateToThis, FormActions)(this);
    $ngRedux.dispatch(rest.actions.timbradosVigentes.reset());
    $ngRedux.dispatch(rest.actions.valores.reset());
    $ngRedux.dispatch(rest.actions.clientesOrdenesFinalizadas.reset());
    $ngRedux.dispatch(rest.actions.cotizacionVigente({}, {
      body: JSON.stringify({
        monedaOrigen: 'Dólares',
        monedaDestino: 'Guaraníes'
      })
    }));
    $ngRedux.dispatch(rest.actions.search.reset());

    const mostrarSwitchDetallarFacturaFilter = Filter.path('codigo').eq('mostrar_switch_detallar_factura');
    const descuentoFilter = Filter.path('codigo').eq('descuento_forma_pago');
    const urlImprimirAutoimpreso = Filter.path('codigo').eq('url_autoimpresor');
    const valorMinimoMonedaFilter = Filter.path('codigo').eq('valor_minimo_moneda');


    const parametroFilter = mostrarSwitchDetallarFacturaFilter
      .or(descuentoFilter)
      .or(urlImprimirAutoimpreso)
      .or(valorMinimoMonedaFilter);

    $ngRedux.dispatch(rest.actions.parametros.get({ filter: JSON.stringify(parametroFilter) }));

    const descuentosFilter = Filter.path('estado.value').eq('Activo')
      .and(Filter.path('porcentajeDescuento').notNull());
    $ngRedux.dispatch(rest.actions.formasPago({ filter: JSON.stringify(descuentosFilter) }));
    const categoriaFilter = Filter.path('clase.value').eq('Producto');
    $ngRedux.dispatch(rest.actions.categoriasProductos({ filter: JSON.stringify(categoriaFilter) }));

    this.initRedux = true;
    let caja = localStorageService.get('caja');

    if (!caja) {
      ngNotify.set(this.translations['Debe asignar una caja al equipo'], 'warn');
      $timeout(() => $state.go('home.cajas.list'));
      return;
    }

    if ($stateParams.uid) {
      this.title = this.view ? this.translations['Ver factura'] : this.translations['Editar factura'];
      this.formEdit('facturas', $stateParams.uid);
    } else {
      this.title = this.translations['Nueva factura'];
      this.form();
      $ngRedux.dispatch(rest.actions.valores.get({ filter: JSON.stringify(valoresFilter) }));
      if (caja) {
        $ngRedux.dispatch(rest.actions.timbradosVigentes({}, {
          body: JSON.stringify({
            cajaId: caja.id,
            sesionCajaId: caja.sesionActual.id,
            puntoEmisionId: caja.puntoEmision.id,
            tipos: ['Factura']
          })
        }));
      }

      $ngRedux.dispatch(rest.actions.clientesValor.get({ filter: JSON.stringify(sinNombreFilter) }));
      $ngRedux.dispatch(rest.actions.clientesOrdenesFinalizadas());
    }

    this.cid = $stateParams.cid;
  };

  this.localModel = {
    fechaFactura: moment(new Date()).format('DD/MM/YYYY'),
    ordenesPorCliente: {},
    ordenesProductoPorCliente: {},
    // Todas las ordenes
    ordenes: [],
    productos: {},
    paquetesCliente: {},
    giftcards: {},
    paquetesClienteParciales: {},
    totalServicios: $filter('currency')(0, 'Gs.', 0),
    totalProductos: $filter('currency')(0, 'Gs.', 0),
    totalPaquetes: $filter('currency')(0, 'Gs.', 0),
    total: $filter('currency')(0, 'Gs.', 0),
    descuentoFormaPago: $filter('currency')(0, 'Gs.', 0),
    toggleFormaPagoDescuento: false,
    // Mantiene monto total y cantidad de ocurrencias de
    // cada servicio en los detalles
    servicios: {},
    // Producto siendo cargado en el modal de agregar producto
    nuevoDetalleProducto: {
      cantidad: 1
    },
    // Productos siendo cargado en el modal de agregar producto
    listProductos: []

  };

  this.opt = {
    fechaOptions: {}
  };

  function mapStateToThis(state) {
    this.handleStatus(state);
    this.submitted = state.form.flags ? state.form.flags.submitted : false;

    let formaPagoDescuento = {};

    if (state.parametros.data && state.parametros.data.length) {

      let mostrarSwitchDetallarFactura = state.parametros.data.filter((v) => v.codigo === 'mostrar_switch_detallar_factura')[0];
      if (mostrarSwitchDetallarFactura && mostrarSwitchDetallarFactura.valor.value == 'SI') {
        this.mostrarSwitchDetallarFactura = true;
      } else {
        this.mostrarSwitchDetallarFactura = false;
      }

      formaPagoDescuento = state.parametros.data.filter((p) => p.codigo === 'descuento_forma_pago')[0];

    }


    this.model = state.form.model || {};

    if (this.initRedux && !this.modelInit && !this.view && !this.model.id && state.valores.data && state.valores.data.length > 0 &&
      state.timbradosVigentes.data && state.timbradosVigentes.data.length > 0) {
      this.modelInit = true;
      this.estados = state.valores.data.filter(v => v.tipo.codigo === 'estado_factura');
      let estadoCreado = this.estados.filter(v => v.value === 'Emitida')[0];

      this.model.estado = estadoCreado;
      if (!this.model.fechaFactura) {
        this.model.fechaFactura = new Date();
      }

      let timbradoDefault = state.timbradosVigentes.data.filter(v => v.tipoComprobanteDefault) || [];
      if (timbradoDefault.length) {
        this.model.timbradoDetalle = timbradoDefault[0];
        this.onSelectTipoComprobante();
      }

      if (!this.model.detalles) {
        this.model.detalles = [];
      }
      // $timeout(() => $scope.$digest(), 1000);
    } else if (!this.modelInit && this.view && this.model.id) {
      //this.model.fechaFactura = moment(this.model.fechaFactura, 'DD/MM/YYYY');
      //this.localModel.fecha = this.model.fechaFactura;
      // console.log("this.localModel.fecha", this.localModel.fecha);
      // console.log("this.model.fechaFactura", this.model.fechaFactura);
      this.modelInit = true;
      this.setTotales();

      this.localModel.servicios = this.model.detalles.filter(v => v.codigo);
      this.localModel.productos = this.model.detalles.filter(v => v.producto);
      this.localModel.giftcards = this.model.detalles.filter(v => v.giftcard);

      let partesNroComprobante = this.model.numeroComprobante.split('-');

      this.localModel.numeroUno = partesNroComprobante[0];
      this.localModel.numeroDos = partesNroComprobante[1];
      this.localModel.timbradoDetalle = `${this.model.tipoComprobante.nombre} (${this.model.tipoComprobante.clase.name} / ${this.model.timbradoDetalle.cabecera.claseTimbrado.name} )`;

      this.localModel.numeroTres = partesNroComprobante[2];
      let caja = localStorageService.get('caja');
      if (this.model.estado.value === 'Emitida' && caja && (caja.sesionActual && caja.sesionActual.estado.value === 'Abierta') && this.model.id) {
        this.cobrarFacturaNotify(this.model.id);
      }
      if (this.model.descuento) {
        this.localModel.descuento = $filter('currency')(this.model.descuento, 'Gs.', 0);
      }
    }

    if (state.clientesValor.data && state.clientesValor.data.length > 0 && this.model.cliente == undefined) {
      this.model.cliente = state.clientesValor.data[0];
    }

    if (state.clientesOrdenesFinalizadas.data && state.clientesOrdenesFinalizadas.data.length > 0 && $stateParams.cid && this.cid) {
      let idCliente = this.cid;
      let self = this;
      this.cid = null;
      let clientesOrdenesFinalizadasFiltrados = state.clientesOrdenesFinalizadas.data.filter(self.filterCliente);

      let clientes = clientesOrdenesFinalizadasFiltrados.filter(e => e.id == idCliente);
      if (clientes.length) {
        loadFinalizadasDeCliente(clientes[0], self);
      }
    }

    if (state.clientesOrdenesFinalizadas.data && state.clientesOrdenesFinalizadas.data.length > 0) {
      let clientesSeleccionRapida = state.clientesOrdenesFinalizadas.data.filter(this.filterClienteSeleccionRapida);
      this.localModel.clientesSeleccionRapida = clientesSeleccionRapida;
    }

    if (state.timbradosVigentes.sync && state.timbradosVigentes.data && this.initRedux) {
      this.hayTimbrados = state.timbradosVigentes.data.length > 0;
    }

    this.tiposPersona = state.valores.data.filter((v) => v.tipo.codigo === 'tipo_persona');

    return {
      form: state.form,
      timbradosVigentes: state.timbradosVigentes.data,
      cotizacionVigente: state.cotizacionVigente.data,
      formasPago: state.formasPago.data,
      clientesOrdenesFinalizadas: state.clientesOrdenesFinalizadas.data,
      tiposDocumento: state.valores.data.filter((v) => v.tipo.codigo === 'tipo_documento'),
      categoriasProducto: state.categoriasProductos.data.filter((v) => v.clase.value === 'Producto'),
      isFormaPagoDescuento: formaPagoDescuento && formaPagoDescuento.valor && formaPagoDescuento.valor.value === 'SI',
      urlAutoimpresor: state.parametros.data.filter((v) => v.codigo === 'url_autoimpresor')[0],
      valorMinimoMoneda: state.parametros.data.filter((v) => v.codigo === 'valor_minimo_moneda')[0]
    };
  }

  function loadFinalizadasDeCliente(cliente, self) {
    $ngRedux.dispatch(rest.actions.finalizadasClientes({ id: cliente.id }, {},
      (err, data) => {
        if (!err) {
          if (data.servicios.length || data.productos.length) {
            self.newDetalleOrdenes(data, cliente);
          } else {
            ngNotify.set(self.translations['El Cliente no posee Órdenes de Trabajo Finalizadas'], 'warn');
          }
        } else if (err) {
          ngNotify.set(err.message, 'warn');
        }
      }));
  }

  function setTotales() {
    let totalServicios = 0;
    let totalProductos = 0;

    this.model.detalles.forEach(function (detalle) {
      let descuento = detalle.descuento ? detalle.descuento : 0;
      if (detalle.producto) {
        totalProductos += detalle.precio - descuento;
      } else {
        totalServicios += detalle.precio - descuento;
      }
    });
    console.log('[this.model]', this.model);
    const total = this.model.total || totalServicios + totalProductos;
    this.localModel.totalServicios = $filter('currency')(totalServicios, 'Gs.', 0);
    this.localModel.totalProductos = $filter('currency')(totalProductos, 'Gs.', 0);
    this.localModel.total = $filter('currency')(total, 'Gs.', 0);
  }

  /**
   * Función que se encarga de mostrar mensajes de error/exito en base al estado actual
   *src/components/reportes/list/reportes.html
   * @param {object} state
   */
  function handleStatus(state) {
    if (state.form.notFound) {
      const msg = `${this.translations['No existe el elemento con ID']} ${$stateParams.uid}`;
      ngNotify.set(msg, 'warn');
      $timeout(() => $state.go('home.facturas.list'));
      return;
    }

    if (state.form.error) {
      ngNotify.set(formatErrorMessage(state.form.error.message), { type: 'error', html: true });
    }

    if (state.timbradosVigentes.error) {
      ngNotify.set(state.timbradosVigentes.error.message, 'error');
      $timeout(() => $state.go('home.cajas.list'));
    }

    if (state.form.created && state.form.created.facturasPersistidasIds && state.form.created.facturasPersistidasIds.length > 0) {
      // Si se creo una sola factura
      if (state.form.created.facturasPersistidasIds.length == 1) {
        // id de la unica factura creada
        let uid = state.form.created.facturasPersistidasIds[0];
        if (state.form.created.cobrar && AuthorizationService.hasPermission('cobrar_facturas')) {
          $state.go('home.facturas.uid.cobrar', { uid: uid });
        } else {
          $state.go('home.facturas.list');
        }
      } else {
        // Se creo mas de una factura, ir a la lista sin ofrecer cobrar ni redirigir a cobrar
        $state.go('home.facturas.list');
      }

      const tipoImpresionComprobante = state.form.created.claseTimbrado;
      if (tipoImpresionComprobante === 'preimpreso') {
        this.imprimirPreimpreso(state.form.created.facturasPersistidasIds);
      } else if (tipoImpresionComprobante === 'autoimpreso') {
        this.imprimirAutoimpreso(state.form.created.facturasPersistidasIds);
      } else {
        ngNotify.set(`Tipo de comprobante no definido (Autoimpreso o Preimpreso)`, 'warn');
      }

    }
  }

  this.imprimirPreimpreso = imprimirPreimpreso.bind(this);
  function imprimirPreimpreso(facturasPersistidasIds) {
    // Imprimir todas las facturas creadas
    const sortedFacturasPersistidasIds = facturasPersistidasIds.sort((a, b) => a - b);
    sortedFacturasPersistidasIds.reduce((downloadsPromiseChain, id) => {
      return downloadsPromiseChain.then(() => {
        return download('facturas', id, 'imprimir-comprobante', config, $resource, HeadersUtil, null, null, true);
      });
    }, Promise.resolve());
  }

  this.imprimirAutoimpreso = imprimirAutoimpreso.bind(this);
  function imprimirAutoimpreso(facturasPersistidasIds) {
    const self = this;
    // Si esta configurada la URL para imprimir autoimpresor
    if (this.urlAutoimpresor && this.urlAutoimpresor.valor && this.urlAutoimpresor.valor.value) {
      const urlAutoimpresor = new URL(this.urlAutoimpresor.valor.value);
      let state = $ngRedux.getState();

      urlAutoimpresor.search = new URLSearchParams({
        endpoint: `${config.serverURL}/facturas/${facturasPersistidasIds[0]}/data-autoimpreso`,
        token: state.login.accessToken.token
      });
      fetch(urlAutoimpresor)
        .then(function (response) {
          if (!response.ok) {
            ngNotify.set(`Error al llamar a servicio de autoimpresión`, 'warn');
          }
        })
        .catch(function () {
          ngNotify.set(`Error al llamar a servicio de autoimpresión`, 'warn');
        });
    }
  }

  function cobrarFacturaNotify(id) {
    if (!AuthorizationService.hasPermission('cobrar_facturas')) {
      return;
    }

    ngNotify.set(this.translations['Comprobante Emitido'] + `<br/><a class="go-in-notify btn btn-danger" href="#/facturas/${id}/cobrar">${this.translations['Cobrar Factura']}</a>`, {
      position: 'bottom',
      duration: 9000,
      type: 'success',
      sticky: true,
      button: true,
      html: true
    });
  }

  function completeNumeroFactura() {
    this.localModel.numeroTres = `${pad(this.localModel.numeroTres, 7)}`;
  }

  function doSubmit() {
    let self = this;
    if ($scope.form.$invalid) {
      this.submitted = true;
      return;
    }

    if (!this.checkFechaComprobanteRangoTimbrado()) {
      return;
    }

    if (this.productosSinPrecio) {
      ngNotify.set(`La orden ${this.productosSinPrecio} tiene productos sin precio establecido`, 'warn');
      return;
    }

    if (this.model.total <= 0) {
      ngNotify.set(`No se puede facturar con total: ${this.model.total}`, 'warn');
      return;
    }

    this.model.numeroComprobante = this.localModel.numeroUno + '-' + this.localModel.numeroDos + '-' + `${pad(this.localModel.numeroTres, 7)}`;
    this.localModel.numeroTres = `${pad(this.localModel.numeroTres, 7)}`;

    let caja = localStorageService.get('caja');
    let data = Object.assign({}, this.model);
    data.tipoComprobante = { id: data.timbradoDetalle.tipoComprobante.id }
    data.timbradoDetalle = { id: data.timbradoDetalle.id };
    data.sesionCajaId = caja.sesionActual.id;

    this.buildDetalles(data);

    if (!data.detalles || !data.detalles.length) {
      ngNotify.set('No se puede guardar una factura sin detalles', 'warn');
      return;
    }

    if (!data.cliente.numeroDocumento) {
      this.localModel.payload = Object.assign({}, data.cliente);
      CustomModal.open({
        title: 'Actualización de Cliente Requerida',
        templateUrl: nuevoClienteTemplate,
        vm: this,
        payload: this.localModel.payload,
        actionLabel: 'Actualizar Cliente y Guardar Factura',
        ok: function () {
          if (!self.localModel.payload.tipoDocumento || !self.localModel.payload.razonSocial) {
            ngNotify.set('Campos faltantes en el formulario de cliente', 'warn');
            return false;
          }
          if (self.localModel.payload.tipoDocumento.value === 'RUC'
            && (!self.localModel.payload.ruc
              || typeof (self.localModel.payload.ruc) !== 'object'
              || !Object.keys(self.localModel.payload.ruc).length)) {
            ngNotify.set('Campos faltantes en el formulario de cliente', 'warn');
            return false;
          }

          data.updateCliente = true;

          if (self.localModel.payload.tipoDocumento.name != "RUC") {
            data.cliente = {
              id: self.localModel.payload.id,
              nombre: self.localModel.payload.nombre,
              apellido: self.localModel.payload.apellido,
              razonSocial: self.localModel.payload.razonSocial,
              ruc: self.localModel.payload.ruc,
              tipoPersona: self.localModel.payload.tipoPersona,
              tipoDocumento: self.localModel.payload.tipoDocumento,
              numeroDocumento: self.localModel.payload.numeroDocumento
            };
          } else {
            data.cliente = {
              id: self.localModel.payload.id,
              nombre: self.localModel.payload.nombre,
              apellido: self.localModel.payload.apellido,
              razonSocial: self.localModel.payload.razonSocial,
              ruc: self.localModel.payload.ruc,
              tipoPersona: self.localModel.payload.tipoPersona,
              tipoDocumento: self.localModel.payload.tipoDocumento,
              numeroDocumento: self.localModel.payload.numeroDocumento + "-" + self.localModel.payload.ruc.digitoVerificador
            };
          }

          self.save('facturas', data);
        }
      });
    } else {
      data.cliente = { id: data.cliente.id };
      this.save('facturas', data);
    }
  }

  function buildDetalles(data) {
    data.detalles = [];
    for (let id in this.localModel.ordenesPorCliente) {
      let ordenesDeCliente = this.localModel.ordenesPorCliente[id];

      Object.keys(ordenesDeCliente.ordenes).forEach(function (key) {
        let orden = ordenesDeCliente.ordenes[key];
        orden.detalles.forEach(function (detalle) {
          let nuevoDetalle = {
            descripcion: detalle.descripcion,
            cantidad: 1,
            descuento: detalle.descuento,
            porcentajeDescuento: detalle.porcentajeDescuento,
            precio: detalle.monto,
            detalle: { id: detalle.id }
          };
          data.detalles.push(nuevoDetalle);
        });
      });
    }

    for (let id in this.localModel.productos) {
      let detalle = this.localModel.productos[id];
      let vendedor = detalle.producto.categoria.solicitarVendedor ? { id: detalle.empleado.id } : null;
      let nuevoDetalle = {
        descripcion: detalle.producto.nombre + this.renderDescripcionProducto(detalle.producto),
        cantidad: detalle.cantidad,
        precio: detalle.monto,
        descuento: detalle.descuento,
        porcentajeDescuento: detalle.porcentajeDescuento,
        vendedor,
        vendedores: Array(detalle.cantidad).fill(vendedor),
        producto: { id: detalle.producto.id }
      };

      // Si ya existia un detalle con este producto, le actualizamos la cantidad y los vendedores
      const detalleMismoProductoExistente = data.detalles.find(d => d.producto && d.producto.id === nuevoDetalle.producto.id);
      if (detalleMismoProductoExistente) {
        detalleMismoProductoExistente.cantidad = detalleMismoProductoExistente.cantidad + nuevoDetalle.cantidad;
        detalleMismoProductoExistente.precio = detalleMismoProductoExistente.precio + nuevoDetalle.precio;
        detalleMismoProductoExistente.descuento = detalleMismoProductoExistente.descuento + nuevoDetalle.descuento;
        for (let i = 0; i < nuevoDetalle.cantidad; i++) {
          detalleMismoProductoExistente.vendedores.push(nuevoDetalle.vendedor);
        }
      } else {
        // Si no, agregamos un nuevo detalle para el producto
        data.detalles.push(nuevoDetalle);
      }

    }

    for (let id in this.localModel.paquetesCliente) {
      let detalle = this.localModel.paquetesCliente[id];
      let paquete;
      if (detalle.id.startsWith('PA')) {
        paquete = { id: detalle.id.split('-')[1] };
      } else {
        paquete = {
          cliente: { id: detalle.cliente.id },
          paquete: { id: detalle.paquete.id }
        };
      }

      let nuevoDetalle = {
        descripcion: detalle.descripcion,
        cantidad: detalle.cantidad,
        precio: detalle.monto,
        paquete
      };
      data.detalles.push(nuevoDetalle);
    }

    for (let id in this.localModel.giftcards) {
      let detalle = this.localModel.giftcards[id];

      let nuevoDetalle = {
        descripcion: `Giftcard ${detalle.codigo}`,
        cantidad: 1,
        precio: detalle.monto,
        giftcard: detalle.giftcard
      };
      data.detalles.push(nuevoDetalle);
    }
  }

  function onSelectTipoComprobante() {
    if (this.localModel.ultimoTibrado && this.model.timbradoDetalle.id === this.localModel.ultimoTibrado.id) {
      return;
    }
    this.localModel.ultimoTibrado = this.model.timbradoDetalle;
    this.model.numeroTimbrado = this.model.timbradoDetalle.cabecera.numero;
    this.model.numeroComprobante = `${pad(this.model.timbradoDetalle.sucursalNumero, 3)}-${pad(this.model.timbradoDetalle.puntoEmision.codigo, 3)}-${pad(this.model.timbradoDetalle.ultimaNumeracion, 7)}`;
    this.localModel.numeroUno = `${pad(this.model.timbradoDetalle.sucursalNumero, 3)}`;
    this.localModel.numeroDos = `${pad(this.model.timbradoDetalle.puntoEmision.codigo, 3)}`;
    this.localModel.numeroTres = `${pad(this.model.timbradoDetalle.ultimaNumeracion, 7)}`;

    this.checkFechaComprobanteRangoTimbrado();
  }

  function renderTipoComprobante(timbradoDetalle) {
    return `<div class="tipo-comprobante-factura">${timbradoDetalle.tipoComprobante.nombre} (${timbradoDetalle.tipoComprobante.clase.name} / ${timbradoDetalle.cabecera.claseTimbrado.name} ) <div class="select-detalles"><small>Timbrado: ${pad(timbradoDetalle.cabecera.numero, 8)} - Vigencia: ${fechaRenderer(timbradoDetalle.cabecera.desde)} a ${fechaRenderer(timbradoDetalle.cabecera.hasta)} <small/></div></div>`;
  }

  function renderFormaPago(formaPago) {
    return `${formaPago.descripcion}`;
  }

  function renderCliente(cliente) {
    let numeroDoc = cliente.numeroDocumento ? cliente.numeroDocumento : 'Sin Nro. Documento';
    return `${cliente.nombreFantasia ? cliente.nombreFantasia + ' -' : ''} ${cliente.razonSocial} <small><strong>(${numeroDoc})</strong></small>`;
  }

  this.renderClienteSeleccionRapida = renderClienteSeleccionRapida.bind(this);

  function renderClienteSeleccionRapida(cliente) {
    return `${cliente.razonSocial}`;
  }

  this.updateRazonSocial = updateRazonSocial.bind(this);

  function updateRazonSocial() {
    this.localModel.payload.razonSocial = `${this.localModel.payload.nombre ? this.localModel.payload.nombre : ''} ${this.localModel.payload.apellido ? this.localModel.payload.apellido : ''}`;
  }

  function nuevoCliente() {
    let self = this;
    this.localModel.payload = {};

    if (this.tiposDocumento) {
      this.localModel.payload.tipoDocumento = this.tiposDocumento.filter((tipo) => tipo.value === 'RUC')[0];
    }

    CustomModal.open({
      title: 'Nuevo Cliente',
      size: 'lg',
      templateUrl: nuevoClienteTemplate,
      backdrop: 'static',
      keyboard: false,
      vm: this,
      payload: this.localModel.payload,
      ok: function () {
        $ngRedux.dispatch(rest.actions.clientes({}, { body: JSON.stringify(self.localModel.payload) },
          (err, data) => {
            if (!err && data && data.id) {
              self.model.cliente = data;
              ngNotify.set(self.translations['Nuevo Cliente Creado'], 'success');
            } else if (err) {
              ngNotify.set(err.message, 'warn');
            }
          }));
      }
    });
  }

  function newDetalleCliente() {
    let self = this;


    $ngRedux.dispatch(rest.actions.clientesOrdenesFinalizadas({}, {},
      (errInit, dataInit) => {
        if (!errInit) {

          self.clientesOrdenesFinalizadasFiltrados = dataInit.filter(self.filterCliente);
          self.localModel.payload = {};

          CustomModal.open({
            title: 'Recuperar Órdenes de Cliente',
            templateUrl: clienteTemplate,
            vm: self,
            payload: self.localModel.payload,
            ok: function () {
              if (!self.localModel.payload.cliente) return false;
              $ngRedux.dispatch(rest.actions.finalizadasClientes({ id: self.localModel.payload.cliente.id }, {},
                (err, data) => {
                  if (!err) {
                    if (data.servicios.length || data.productos.length) {
                      self.newDetalleOrdenes(data, self.localModel.payload.cliente);
                    } else {
                      ngNotify.set(self.translations['El Cliente no posee Órdenes de Trabajo Finalizadas'], 'warn');
                    }
                  } else if (err) {
                    ngNotify.set(err.message, 'warn');
                  }
                }));
            }
          });
        } else if (errInit) {
          ngNotify.set(errInit.message, 'warn');
        }
      }));


  }

  function newDetalleOrdenes(ordenes, cliente) {
    let self = this;

    let ordenesDeCliente = {
      cliente,
      ordenes: {}
    };

    let ordenesProductoDeCliente = {
      cliente,
      productos: []
    };

    // Si existe algun producto o servicio con precio en Dolares y no hay cotiacion, retornar
    // sin agregar la/s orden/es del cliente
    let cotizacionDisponible = this.cotizacionVigente && Object.keys(this.cotizacionVigente).length > 0;
    if (this.serviciosContienePrecioDolares(ordenes.servicios) && !cotizacionDisponible) {
      ngNotify.set(`Servicio con precio en Usd: No se encontró cotización vigente de Usd. a Gs.`, 'warn');
      return;
    }
    if (this.productosContienePrecioDolares(ordenes.productos) && !cotizacionDisponible) {
      ngNotify.set(`Producto con precio en Usd: No se encontró cotización vigente de Usd. a Gs.`, 'warn');
      return;
    }

    ordenes.servicios.forEach(function (ordenDetalle) {
      establecerDescripcionMonto(ordenDetalle, self);
      ordenesDeCliente.ordenes[ordenDetalle.orden.numero] = ordenesDeCliente.ordenes[ordenDetalle.orden.numero] || { orden: ordenDetalle.orden, detalles: [] };
      ordenesDeCliente.ordenes[ordenDetalle.orden.numero].detalles.push(ordenDetalle);

      // Actualizar monto total y cantidad de ocurrencias del servicio
      let montoTotalActualServicio = self.localModel.servicios[ordenDetalle.servicio.id] ?
        self.localModel.servicios[ordenDetalle.servicio.id].monto : 0;
      let ocurrenciasTotalActualServicio = self.localModel.servicios[ordenDetalle.servicio.id] ?
        self.localModel.servicios[ordenDetalle.servicio.id].ocurrencias : 0;
      let ordenesPadre = self.localModel.servicios[ordenDetalle.servicio.id] ?
        self.localModel.servicios[ordenDetalle.servicio.id].ordenesPadre : [];
      self.localModel.servicios[ordenDetalle.servicio.id] = {
        'monto': montoTotalActualServicio + ordenDetalle.servicio.precio.monto,
        'ocurrencias': ocurrenciasTotalActualServicio + 1,
        'ordenesPadre': ordenesPadre.concat(ordenDetalle.orden)
      };
    });

    let productos = this.localModel.productos || {};
    ordenes.productos.forEach(function (ordenDetalle) {
      ordenesProductoDeCliente.productos.push(ordenDetalle);

      if (!ordenDetalle.producto.precio) {
        ngNotify.set(`Producto ${ordenDetalle.producto.nombre} sin precio establecido`, 'warn');
        return;
      }

      let idMap = ordenDetalle.producto.id + '-' + ordenDetalle.orden.numero;
      if (ordenDetalle.producto.categoria.solicitarVendedor) {
        if (ordenDetalle.especialista) {
          idMap = idMap + '-' + ordenDetalle.especialista.id;
        } else {
          idMap = idMap + '--';
        }

      }

      if (productos[idMap]) {
        let cantidad = productos[idMap].cantidad + ordenDetalle.cantidad;
        let monto;
        if (ordenDetalle.producto.precio.moneda.value === 'Guaraníes') {
          monto = ordenDetalle.producto.precio.monto * cantidad;
        } else if (ordenDetalle.producto.precio.moneda.value === 'Dólares') {
          monto = ordenDetalle.producto.precio.monto * self.cotizacionVigente.valorVenta * cantidad;
        }
        productos[idMap].cantidad = cantidad;
        productos[idMap].monto = monto;
      } else {
        let cantidad = ordenDetalle.cantidad;
        let monto;
        if (ordenDetalle.producto.precio.moneda.value === 'Guaraníes') {
          monto = ordenDetalle.producto.precio.monto * cantidad;
        } else if (ordenDetalle.producto.precio.moneda.value === 'Dólares') {
          monto = ordenDetalle.producto.precio.monto * self.cotizacionVigente.valorVenta * cantidad;
        }
        productos[idMap] = {
          orden: ordenDetalle.orden.numero,
          producto: ordenDetalle.producto,
          empleado: ordenDetalle.especialista,
          cantidad: ordenDetalle.cantidad,
          monto
        };
      }
    });

    if (!this.model.cliente || this.model.cliente.numeroDocumento === '44444401-7') {
      if (cliente.asociacionFactura) {
        this.model.cliente = cliente.asociacionFactura;
      } else {
        this.model.cliente = cliente;
      }
    }

    this.localModel.ordenesPorCliente[cliente.id] = ordenesDeCliente;
    this.localModel.ordenesProductoPorCliente[cliente.id] = ordenesProductoDeCliente;
    this.localModel.productos = productos;
    this.updateTotales();
    this.actualizarOrdenes();

    let clientesSeleccionRapida = this.clientesOrdenesFinalizadas.filter(this.filterClienteSeleccionRapida);
    this.localModel.clientesSeleccionRapida = clientesSeleccionRapida;
  }

  function updateTotales() {
    let totalServicios = 0;
    let totalProductos = 0;
    let totalPaquetes = 0;
    let totalGiftcards = 0;
    let totalDescuentoDiplomatico = 0;
    let totalMostrar = 0;

    const clienteDiplomatico = this.model.cliente && this.model.cliente.diplomatico;
    const porcentajeDescuentoFormaPago = (this.model.formaPagoDescuento && this.model.formaPagoDescuento.porcentajeDescuento) || 0;

    for (let id in this.localModel.ordenesPorCliente) {
      let ordenesDeCliente = this.localModel.ordenesPorCliente[id];
      Object.keys(ordenesDeCliente.ordenes).forEach(function (key) {
        let orden = ordenesDeCliente.ordenes[key];
        orden.detalles.forEach(function (detalle) {
          let descuento = detalle.descuento || 0;
          totalServicios += (detalle.monto - descuento);
          if (clienteDiplomatico) {
            const precio = detalle.monto - descuento;
            const porcentajeImpuesto = detalle.servicio.tipoImpuesto.porcentaje;
            const iva = porcentajeImpuesto > 0 ? precio / divisorIvaByPorcentaje(porcentajeImpuesto) : 0;
            totalDescuentoDiplomatico += Math.round(iva);
          }
        });
      });
    }

    for (let id in this.localModel.productos) {
      let detalle = this.localModel.productos[id];
      let descuento = detalle.descuento || 0;
      totalProductos += (detalle.monto - descuento);
      if (clienteDiplomatico) {
        const precio = detalle.monto - descuento;
        const porcentajeImpuesto = detalle.producto.tipoImpuesto.porcentaje;
        const iva = porcentajeImpuesto > 0 ? precio / divisorIvaByPorcentaje(porcentajeImpuesto) : 0;
        totalDescuentoDiplomatico += Math.round(iva);
      }
    }

    for (let id in this.localModel.paquetesCliente) {
      let detalle = this.localModel.paquetesCliente[id];
      let descuento = detalle.descuento || 0;
      totalPaquetes += (detalle.monto - descuento);
      if (clienteDiplomatico) {
        const precio = detalle.monto - descuento;
        const porcentajeImpuesto = getPorcentajeImpuestoPaquete(detalle);
        const iva = porcentajeImpuesto > 0 ? precio / divisorIvaByPorcentaje(porcentajeImpuesto) : 0;
        totalDescuentoDiplomatico += Math.round(iva);
      }
    }

    for (let id in this.localModel.giftcards) {
      let detalle = this.localModel.giftcards[id];
      let descuento = detalle.descuento || 0;
      totalGiftcards += (detalle.monto - descuento);
      if (clienteDiplomatico) {
        const precio = detalle.monto - descuento;
        // Se asume IVA 10 para giftcards
        const porcentajeImpuesto = 10;
        const iva = precio / divisorIvaByPorcentaje(porcentajeImpuesto);
        totalDescuentoDiplomatico += Math.round(iva);
      }
    }

    this.localModel.totalServicios = $filter('currency')(totalServicios, 'Gs.', 0);
    this.localModel.totalProductos = $filter('currency')(totalProductos, 'Gs.', 0);
    this.localModel.totalPaquetes = $filter('currency')(totalPaquetes + totalGiftcards, 'Gs.', 0);
    this.localModel.totalGiftcards = $filter('currency')(totalGiftcards, 'Gs.', 0);
    const totalCalculado = totalServicios + totalProductos + totalPaquetes + totalGiftcards;
    this.localModel.descuentoDiplomatico = $filter('currency')(totalDescuentoDiplomatico, 'Gs.', 0);
    // Si existe descuento por forma de pago, reflejarlo en la seccion de totales
    const descuentoFormaPago = totalCalculado * porcentajeDescuentoFormaPago / 100;
    this.localModel.descuentoFormaPago = $filter('currency')(descuentoFormaPago, 'Gs.', 0);
    totalMostrar = totalCalculado - descuentoFormaPago - totalDescuentoDiplomatico;

    if (this.valorMinimoMoneda) {
      const valorMinMoneda = (this.valorMinimoMoneda && this.valorMinimoMoneda.valor && this.valorMinimoMoneda.valor.value) || 0;
      totalMostrar = valorMinMoneda == 0 ? totalMostrar : totalMostrar - (totalMostrar % valorMinMoneda);
    }

    this.localModel.total = $filter('currency')(totalMostrar, 'Gs.', 0);

    // Model para el back, se va conteniendo el descuento por forma de pago, ya que el backend resta
    this.model.total = totalCalculado;
  }

  /**
   * Funcion utilitaria que calcula el numero por el que debe ser dividido un monto para calcular su IVA, en funcion
   * al porcentaje de impuesto.
   * @param porcentaje Porcentaje de impuesto que aplica.
   * @returns {number} Numero por el que debe ser dividido un monto para calcular su IVA, en funcion.
   */
  function divisorIvaByPorcentaje(porcentaje) {
    if (porcentaje === 10) {
      return 11;
    } else if (porcentaje === 5) {
      return 21;
    } else {
      return Number.MAX_VALUE;
    }
  }

  /**
   * @param paquete Paquete cuyo porcentaje de impuesto se desea saber.
   * @returns {number} Porcentaje de impuesto del servicio de un paquete, o 10 por defecto
   */
  function getPorcentajeImpuestoPaquete(paquete) {
    return (paquete
      && paquete.servicio
      && paquete.servicio.tipoImpuesto
      && paquete.servicio.tipoImpuesto.porcentaje) || 10;
  }

  function establecerDescripcionMonto(ordenDetalle, self) {
    let nombre = ordenDetalle.servicio.nombre;
    if (!ordenDetalle.servicio.precio) {
      ngNotify.set('El servicio ' + ordenDetalle.servicio.nombre + ' no posee un precio asociado.', 'error');
      return;
    }
    let monto;
    if (ordenDetalle.servicio.precio.moneda.value === 'Guaraníes') {
      monto = ordenDetalle.servicio.precio.monto;
    } else if (ordenDetalle.servicio.precio.moneda.value === 'Dólares') {
      monto = ordenDetalle.servicio.precio.monto * self.cotizacionVigente.valorVenta;
    }
    ordenDetalle.detalles.forEach(function (detalle) {
      monto += detalle.monto;
      let parte = detalle.adicional ? detalle.nombres.adicional : detalle.nombres.tipoProductoAdicional;
      nombre += ` + ${parte}`;
    });

    ordenDetalle.descripcion = nombre;
    ordenDetalle.monto = monto;
  }

  this.renderMontoView = renderMontoView.bind(this);

  function renderMontoView(ordenDetalle) {
    let precio = ordenDetalle.descuento ? ordenDetalle.precio - ordenDetalle.descuento : ordenDetalle.precio;
    return $filter('currency')(precio, 'Gs.', 0);
  }

  function renderMontoOrden(ordenDetalle) {
    return ordenDetalle.descuento ? ordenDetalle.monto - ordenDetalle.descuento : ordenDetalle.monto;
  }

  this.renderMontoUnitarioOrden = renderMontoUnitarioOrden.bind(this);
  function renderMontoUnitarioOrden(ordenDetalle) {
    const montoTotal = ordenDetalle.descuento ? ordenDetalle.monto - ordenDetalle.descuento : ordenDetalle.monto;
    const cantidad = ordenDetalle.cantidad || 1;
    const montoUnitario = Math.round(montoTotal / cantidad);
    return $filter('currency')(montoUnitario, 'Gs.', 0);
  }

  this.renderMontoUnitarioPaquete = renderMontoUnitarioPaquete.bind(this);
  function renderMontoUnitarioPaquete(paqueteDetalle) {
    const montoTotal = paqueteDetalle.descuento ? paqueteDetalle.monto - paqueteDetalle.descuento : paqueteDetalle.monto;
    const cantidad = paqueteDetalle.cantidad || 1;
    const montoUnitario = Math.round(montoTotal / cantidad);
    return $filter('currency')(montoUnitario, 'Gs.', 0);
  }



  this.renderMontoProducto = renderMontoProducto.bind(this);
  function renderMontoProducto(productoDetalle) {
    return productoDetalle.descuento ? productoDetalle.monto - productoDetalle.descuento : productoDetalle.monto;
  }

  this.renderMontoUnitarioProducto = renderMontoUnitarioProducto.bind(this);
  function renderMontoUnitarioProducto(productoDetalle) {
    const montoTotal = productoDetalle.descuento ? productoDetalle.monto - productoDetalle.descuento : productoDetalle.monto;
    const cantidad = productoDetalle.cantidad || 1;
    const montoUnitario = Math.round(montoTotal / cantidad);
    return $filter('currency')(montoUnitario, 'Gs.', 0);
  }

  this.updateMonto = updateMonto.bind(this);

  function updateMonto(detalle, descuento, porcentaje) {
    // Si el descuento aplicado al detalle es por porcentaje
    if (porcentaje) {
      detalle.porcentajeDescuento = descuento;
      detalle.descuento = detalle.monto * descuento / 100;
    } else {
      // Sino, es por monto, y se aplica directamente
      detalle.descuento = descuento;
    }

    this.updateTotales();
  }

  this.renderDescuento = renderDescuento.bind(this);

  function renderDescuento(ordenDetalle) {
    if (ordenDetalle.descuento && ordenDetalle.descuento > 0) {
      return $filter('currency')(ordenDetalle.descuento, 'Gs.', 0);
    }
  }

  function renderDescripcionOrden(ordenDetalle) {
    return ordenDetalle.descripcion;
  }

  function renderDescripcionProducto(producto) {
    return `${getMarca(producto.marca)}${getPresentacion(producto.presentacion)}${getUnidadMedida(producto.unidadMedida)}`;
  }

  function getUnidadMedida(unidadMedida) {
    return unidadMedida ? ` -  (${unidadMedida.abreviatura})` : '';
  }

  function getMarca(marca) {
    return marca ? ' - Marca: ' + marca.nombre : '';
  }

  function getPresentacion(presentacion) {
    if (!presentacion) {
      return;
    }
    let dimensiones = [];
    if (presentacion.largo) dimensiones.push(`Lo${presentacion.largo}`);
    if (presentacion.ancho) dimensiones.push(`An${presentacion.ancho}`);
    if (presentacion.alto) dimensiones.push(`Al${presentacion.alto}`);
    if (presentacion.peso) dimensiones.push(`Pe${presentacion.peso}`);

    return dimensiones.length ? ` - Presentación: ${dimensiones.join('x')}` : '';
  }

  this.renderDescripcionPago = renderDescripcionPago.bind(this);

  function renderDescripcionPago(pago) {
    let descripcion = '';
    if (pago.formaPago.formaDesembolso.name === 'Efectivo') {
      descripcion = 'N/A';
    } else if (pago.formaPago.formaDesembolso.name === 'Cheque') {
      if (pago.chequeNumero) {
        descripcion += `Nro. Cheque: ${pago.chequeNumero}`;
      } else {
        descripcion += 'Sin Nro. Cheque';
      }

      if (pago.chequeEntidadBancaria) {
        descripcion += ` - Banco: ${pago.chequeEntidadBancaria}`;
      } else {
        descripcion += ' - Sin Banco Especificado';
      }

      if (pago.chequeNumeroCuenta) {
        descripcion += ` - Cuenta: ${pago.chequeNumeroCuenta}`;
      } else {
        descripcion += ' - Sin Cuenta Especificada';
      }

    } else if (pago.formaPago.formaDesembolso.name === 'Tarjeta de crédito' ||
      pago.formaPago.formaDesembolso.name === 'Tarjeta de débito') {
      if (pago.procesadoraTarjeta) {
        descripcion += `Procesadora: ${pago.procesadoraTarjeta.nombre}`;
      } else {
        descripcion += 'Sin Procesadora Especificada';
      }

      if (pago.emisorTarjeta) {
        descripcion += ` - Emisor: ${pago.emisorTarjeta.nombre}`;
      } else {
        descripcion += ' - Sin Emisor Especificado';
      }

      if (pago.marcaTarjeta) {
        descripcion += ` - Marca: ${pago.marcaTarjeta.nombre}`;
      } else {
        descripcion += ' - Sin Marca Especificada';
      }

      if (pago.numeroVoucher) {
        descripcion += ` - Voucher: ${pago.numeroVoucher}`;
      }
    } else if (pago.formaPago.formaDesembolso.name === 'Nota de Crédito') {
      if (pago.timbradoNotaCredito) {
        descripcion += `Timbrado: ${pago.timbradoNotaCredito}`;
      }

      if (pago.numeroComprobanteNotaCredito) {
        descripcion += `${descripcion === '' ? '' : ' - '}Nro. Comprobante: ${pago.numeroComprobanteNotaCredito}`;
      }


      if (descripcion === '') {
        descripcion = 'No se registró Timbrado ni Nro. Comprobante';
      }
    }

    if (pago.timbradoRetencion) {
      descripcion += `Timbrado: ${pago.timbradoRetencion}`;
    }

    if (pago.numeroComprobanteRetencion) {
      descripcion += ` - Nro. Comprobante: ${pago.numeroComprobanteRetencion}`;
    }

    if (pago.numeroOperacionTransferencia) {
      descripcion += `Nro. Operación Transferencia: ${pago.numeroOperacionTransferencia}`;
    }

    return descripcion;
  }

  function newDetalleProductoModal() {
    let self = this;
    this.localModel.payload = {
      cantidad: 1
    };
    CustomModal.open({
      size: 'lg',
      headerClass: 'font-large',
      title: 'Agregar Productos a la Factura',
      templateUrl: productoTemplate,
      vm: this,
      payload: this.localModel.payload,
      ok: function () {
        if (!(self.localModel.listProductos && self.localModel.listProductos.length > 0)) {
          ngNotify.set(`Debe agregar un producto`, 'warn');
          return false;
        }

        self.localModel.listProductos.forEach((p) => {
          let producto = p.producto;
          let empleado = producto.empleado;
          let cantidad = p.cantidad;
          let monto;
          if (producto.precio.moneda.value === 'Guaraníes') {
            monto = producto.precio.monto * cantidad;
          } else if (producto.precio.moneda.value === 'Dólares') {
            monto = producto.precio.monto * self.cotizacionVigente.valorVenta * cantidad;
          }
          // Si el producto ya estaba entre los productos de la factura, sumar cantidad y monto
          if (self.localModel.productos[producto.id]) {
            monto = self.localModel.productos[producto.id].monto + monto;
            cantidad = self.localModel.productos[producto.id].cantidad + cantidad;
          }

          delete producto.empleado;
          self.localModel.productos[producto.id] = {
            producto,
            empleado,
            cantidad,
            monto
          };
        });

        // Vaciar la lista de productos del modal
        self.localModel.listProductos = [];

        self.updateTotales();
      }
    });
  }

  /**
   * Agregar un nuevo producto a la lista de productos del modal
   * (Que necesita ser confirmado para ser agregados a la factura)
   */
  this.newDetalleProducto = newDetalleProducto.bind(this);
  function newDetalleProducto() {
    if (!this.localModel.nuevoDetalleProducto.producto) {
      ngNotify.set(`Debe seleccionar un producto`, 'warn');
      return;
    }

    if (!this.localModel.nuevoDetalleProducto.cantidad || this.localModel.nuevoDetalleProducto.cantidad === 0) {
      ngNotify.set(`La cantidad debe ser mayor a cero`, 'warn');
      return;
    }
    // Si el precio esta en dolares y no hay cotizacion mostrar un mensaje y no dejar agregar
    // Por ahora se asume que la unica otra moneda posible es el Dolar
    if (this.localModel.nuevoDetalleProducto.producto.precio.moneda.value === 'Dólares' && (!this.cotizacionVigente || Object.keys(this.cotizacionVigente).length === 0)) {
      ngNotify.set(`No se encontró cotización vigente de Usd. a Gs.`, 'warn');
      return;
    }
    this.localModel.listProductos.push(this.localModel.nuevoDetalleProducto);
    this.localModel.nuevoDetalleProducto = { cantidad: 1 };
  }

  /**
   * Eliminar un producto de la lista de productos del modal
   * (Que necesita ser confirmado para ser agregados a la factura)
   */
  this.removeDetalleProducto = removeDetalleProducto.bind(this);
  function removeDetalleProducto(index) {
    this.localModel.listProductos.splice(index, 1);
  }

  this.selectCliente = selectCliente.bind(this);

  function selectCliente(cliente) {
    loadFinalizadasDeCliente(cliente, this);
  }

  this.renderEmpleado = renderEmpleado.bind(this);

  function renderEmpleado(empleado) {
    return `${empleado.nombre} ${empleado.apellido}`;
  }

  this.loadEmpleados = loadEmpleados.bind(this);

  function loadEmpleados(query) {
    let filter = Filter.path('activo').eq(true);
    if (query) {
      filter = filter.and(Filter.path('nombre').like(query)
        .or(Filter.path('apellido').like(query)));
    }

    // Ordenamiento de empleados para que aparezcan los de tipo 'Normal', antes que 'Especialista'
    let sorting = {
      sortingConditions: [
        {
          path: 'tipoEmpleado.value',
          sortingType: 'desc'
        }
      ]
    };

    BasicFactory.setup('empleados');
    return filter ? BasicFactory.all({ filter: JSON.stringify(filter), sorting: JSON.stringify(sorting) }) : BasicFactory.all();
  }

  function deleteDetalleOrden(detalle) {

    let numeroOrdenes = Object.keys(this.localModel.ordenesPorCliente[detalle.cliente.id].ordenes);
    let keysProductos = Object.keys(this.localModel.productos);

    for (let i = 0; i < keysProductos.length; i++) {
      for (let j = 0; j < numeroOrdenes.length; j++) {
        if (this.localModel.productos[keysProductos[i]].orden == numeroOrdenes[j]) {
          delete this.localModel.productos[keysProductos[i]];
        }
      }
    }

    delete this.localModel.ordenesPorCliente[detalle.cliente.id];

    this.updateTotales();
    this.actualizarOrdenes();
    let self = this;
    // Actualizar monto total y cantidad de ocurrencias de servicios
    let idsOrdenes = Object.keys(detalle.ordenes);
    for (let i = 0; i < idsOrdenes.length; i++) {
      let idOrden = idsOrdenes[i];
      let detalles = detalle.ordenes[idOrden].detalles;
      detalles.forEach((detalle) => {
        let servicio = detalle.servicio;
        let montoTotalActualServicio = self.localModel.servicios[servicio.id] ? self.localModel.servicios[servicio.id].monto : 0;
        let ocurrenciasTotalActualServicio = self.localModel.servicios[servicio.id] ? self.localModel.servicios[servicio.id].ocurrencias : 0;
        let ordenesPadre = self.localModel.servicios[servicio.id] ? self.localModel.servicios[servicio.id].ordenesPadre : [];
        if (ocurrenciasTotalActualServicio == 1) {
          delete self.localModel.servicios[servicio.id];
        } else {
          self.localModel.servicios[servicio.id] = {
            'monto': montoTotalActualServicio - servicio.precio.monto,
            'ocurrencias': ocurrenciasTotalActualServicio - 1,
            'ordenesPadre': ordenesPadre.filter((value, index, arr) => value.id !== detalle.orden.id)
          };
        }
      });
    }
  }

  function deleteOrden(detalle, cliente) {
    // Actualizar monto total y cantidad de ocurrencias de servicios
    let idsDetalles = Object.keys(detalle.detalles);
    for (let i = 0; i < idsDetalles.length; i++) {
      let idDetalle = idsDetalles[i];
      let servicio = detalle.detalles[idDetalle].servicio;
      let montoTotalActualServicio = this.localModel.servicios[servicio.id] ? this.localModel.servicios[servicio.id].monto : 0;
      let ocurrenciasTotalActualServicio = this.localModel.servicios[servicio.id] ? this.localModel.servicios[servicio.id].ocurrencias : 0;
      let ordenesPadre = this.localModel.servicios[servicio.id] ? this.localModel.servicios[servicio.id].ordenesPadre : [];
      if (ocurrenciasTotalActualServicio == 1) {
        delete this.localModel.servicios[servicio.id];
      } else {
        this.localModel.servicios[servicio.id] = {
          'monto': montoTotalActualServicio - servicio.precio.monto,
          'ocurrencias': ocurrenciasTotalActualServicio - 1,
          'ordenesPadre': ordenesPadre.filter((value, index, arr) => value.id !== detalle.orden.id)
        };
      }
    }

    let self = this;
    delete this.localModel.ordenesPorCliente[cliente.id].ordenes[detalle.orden.numero];
    Object.keys(this.localModel.productos).forEach(function (key, index) {
      if (self.localModel.productos[key].orden === detalle.orden.numero) {
        delete self.localModel.productos[key];
      }
    });
    this.updateTotales();
    this.actualizarOrdenes();

  }

  function deleteDetalleProducto(detalle) {
    delete this.localModel.productos[detalle.producto.id];
    this.updateTotales();
    //_.remove(this.model.detalles, detalle);
  }

  function renderProducto(producto) {
    let simboloMoneda = 'Gs.';
    if (producto.precio && producto.precio.moneda.value === 'Dólares') {
      simboloMoneda = 'Usd.';
    }
    return `${producto.nombre} (${producto.codigo}${producto.codigoBarra ? ' / ' + producto.codigoBarra : ''}) - Precio: ${$filter('currency')(producto.precio ? producto.precio.monto : '-', simboloMoneda, 0)} (${producto.tipoImpuesto.porcentaje}%) ${renderDescripcionProducto(producto)}`;
  }

  function renderPaquete(paquete) {
    return `${paquete.codigo} - ${paquete.servicio.nombre} 
            - Sesiones: ${paquete.cantidadSesiones}`;
  }

  this.renderPaqueteCliente = renderPaqueteCliente.bind(this);

  function renderPaqueteCliente(paqueteCliente) {
    return `<div class="paquete">${paqueteCliente.paquete.codigo} (${paqueteCliente.paquete.servicio.nombre}) <div class="select-detalles"><small>Sesiones Pagadas: ${paqueteCliente.cantidadSesionesPagadas} - Sesiones Ejecutadas: ${paqueteCliente.cantidadSesionesEjecutadas}  <small/></div></div>`;
  }

  this.fieldsToShowProducto = ['nombre', 'codigoBarra', 'codigo'];
  function loadProductos(query) {
    if (!this.localModel.nuevoDetalleProducto.categoria || !query) {
      return;
    }

    let filterCategoria = Filter.path('categoria.id').eq(this.localModel.nuevoDetalleProducto.categoria.id);
    let filterClase = Filter.path('categoria.clase.value').eq('Producto');
    let filterActivo = Filter.path('estado.value').eq('Activo');

    let filter = filterCategoria.and(filterClase).and(filterActivo);

    filter = filter.and(Filter.path('nombre').like(query))
      .or(Filter.path('codigoBarra').like(query))
      .or(Filter.path('codigo').like(query));

    BasicFactory.setup('productos');
    return BasicFactory.all({ filter: JSON.stringify(filter) });
  }

  function newDetallePaquete() {
    let self = this;
    this.localModel.payload = {
      meta: { nuevo: true },
      cantidad: 1
    };

    CustomModal.open({
      title: 'Agregar Paquete a la Factura',
      size: 'lg',
      templateUrl: paquetesTemplate,
      vm: this,
      payload: this.localModel.payload,
      ok: function () {
        if (!self.localModel.payload.cliente || !self.localModel.payload.paquete) return false;

        let id;
        if (self.localModel.payload.meta.paqueteParcial) {
          self.localModel.paquetesClienteParciales[self.localModel.payload.meta.paqueteParcial.id] = true;
          id = `PA-${self.localModel.payload.meta.paqueteParcial.id}`;
        } else { //paquete nuevo
          let contador = 0;
          id = generarId(self.localModel.payload.paquete.codigo, contador);
          let paqueteEnDetalles = self.localModel.paquetesCliente[id];
          while (paqueteEnDetalles) {
            contador++;
            id = generarId(self.localModel.payload.paquete.codigo, contador);
            paqueteEnDetalles = self.localModel.paquetesCliente[id];
          }
        }

        function generarId(codigo, contador) {
          return `PN-${codigo}${contador}`;
        }

        function generarDescripcion(paquete, paqueteCliente, cantidad, id) {
          let descripcion;
          let cantidadTotal = cantidad;
          if (id.startsWith('PN')) {
            descripcion = '[Paquete Nuevo]';
          } else {
            descripcion = '[Ya facturado]';
            cantidadTotal += paqueteCliente.cantidadSesionesPagadas;
          }

          if (cantidadTotal === paquete.cantidadSesiones) {
            descripcion += `[Pago Completo ${cantidadTotal}/${cantidadTotal}]`;
          } else {
            descripcion += `[Pago Parcial ${cantidadTotal}/${paquete.cantidadSesiones}]`;
          }

          return `(${paquete.codigo}) ${paquete.servicio.nombre} ${descripcion}`;
        }

        self.localModel.paquetesCliente[id] = {
          id,
          paquete: self.localModel.payload.paquete,
          cantidad: self.localModel.payload.cantidad,
          cliente: self.localModel.payload.cliente,
          descripcion: generarDescripcion(self.localModel.payload.paquete, self.localModel.payload.meta.paqueteParcial, self.localModel.payload.cantidad, id),
          monto: self.localModel.payload.paquete.montoSesion * self.localModel.payload.cantidad
        };
        self.updateTotales();
      }
    });
  }

  function newDetalleGiftcard() {
    let self = this;
    this.localModel.payload = {};

    CustomModal.open({
      title: 'Agregar Giftcard a la Factura',
      templateUrl: giftcardTemplate,
      vm: this,
      payload: this.localModel.payload,
      venta: true,
      ok: function () {
        if (!self.localModel.payload.giftcard) return false;

        let id = self.localModel.payload.giftcard.codigo;

        self.localModel.giftcards[id] = {
          id,
          giftcard: self.localModel.payload.giftcard,
          monto: self.localModel.payload.giftcard.monto
        };
        self.updateTotales();
      }
    });
  }

  this.borrarDescuento = borrarDescuento.bind(this);

  function borrarDescuento() {
    this.model.descuento = null;
    this.model.giftcard = null;
  }

  this.borrarFormaPagoDescuento = borrarFormaPagoDescuento.bind(this);

  function borrarFormaPagoDescuento() {
    this.localModel.toggleFormaPagoDescuento = false;
    this.model.formaPagoDescuento = null;
    this.localModel.descuentoFormaPago = null;
    this.updateTotales();
  }

  this.selectGiftcard = selectGiftcard.bind(this);


  function selectGiftcard() {
    let self = this;

    // Si la giftcard no tiene un servicio asociado, puede ser de tipo Monto
    // o Gentileza sin servicio. Ambos casos son tratados solamente teniendo
    // en cuenta el monto.
    if (!self.localModel.payload.giftcard.servicio) {
      // Si cubre totalmente el monto de la factura, se ofrece canjear
      if (self.localModel.payload.giftcard.montoRestante >= self.model.total) {
        //canjear la giftcard
        self.localModel.canjeOptions.title = 'Canje de Giftcard';
        self.localModel.canjeOptions.enabled = true;
        self.localModel.canjeOptions.label = 'Canjear Giftcard y Terminar';
        let nuevoMontoRestante = self.localModel.payload.giftcard.montoRestante - self.model.total;
        self.localModel.canjeOptions.message = `La giftcard ${self.localModel.payload.giftcard.codigo} se puede canjear para cubrir el monto total ${self.localModel.total} de la factura.`
        if (nuevoMontoRestante) {
          self.localModel.canjeOptions.message += `\nLa giftcard tendrá saldo pendiente de ${$filter('currency')(nuevoMontoRestante, 'Gs.', 0)}`;
        }
      } else {
        // Si no cubre totalmente se ofrece aplicar el descuento
        self.localModel.canjeOptions.title = 'Agregar Descuento con Giftcard';
        self.localModel.canjeOptions.enabled = false;
        self.localModel.canjeOptions.message = null;
        self.localModel.canjeOptions.label = 'Agregar Descuento';
      }
    } else {
      // La giftcard tiene un servicio asociado
      let giftcard = self.localModel.payload.giftcard;
      // Si cubre totalmente el monto de la factura, y en los detalles
      // hay un solo servicio se ofrece canjear
      if (giftcard.montoRestante >= self.model.total && Object.keys(self.localModel.servicios).length === 1) {
        //canjear la giftcard
        self.localModel.canjeOptions.title = 'Canje de Giftcard';
        self.localModel.canjeOptions.enabled = true;
        self.localModel.canjeOptions.label = 'Canjear Giftcard y Terminar';
        let nuevoMontoRestante = giftcard.montoRestante - self.model.total;
        self.localModel.canjeOptions.message = `La giftcard ${giftcard.codigo} se puede canjear para cubrir el monto total ${self.localModel.total} de la factura.`
        if (nuevoMontoRestante) {
          self.localModel.canjeOptions.message += `\nLa giftcard tendrá saldo pendiente de ${$filter('currency')(nuevoMontoRestante, 'Gs.', 0)}`;
        }
      } else {
        // Si no cubre totalmente el monto del servicio al que aplica la giftcard se ofrece aplicar el descuento
        self.localModel.canjeOptions.title = 'Agregar Descuento con Giftcard';
        self.localModel.canjeOptions.enabled = false;
        self.localModel.canjeOptions.message = null;
        self.localModel.canjeOptions.label = 'Agregar Descuento';
      }
    }
  }

  function newDescuentoGiftcard() {
    let self = this;
    this.localModel.payload = {};
    this.localModel.canjeOptions = {
      enabled: false,
      title: 'Agregar Descuento con Giftcard',
      label: 'Agregar Descuento'
    };

    CustomModal.open({
      templateUrl: giftcardTemplate,
      vm: this,
      canjeOptions: this.localModel.canjeOptions,
      venta: false,
      payload: this.localModel.payload,

      ok: function () {
        if (!self.localModel.payload.giftcard) return false;

        if (self.localModel.payload.giftcard.montoRestante >= self.model.total) {
          //canjear la giftcard
          let requestPayload = { ordenesDetalles: [], montoTotal: self.model.total };
          let cancelar = false;
          for (let id in self.localModel.ordenesPorCliente) {
            let ordenesDeCliente = self.localModel.ordenesPorCliente[id];

            Object.keys(ordenesDeCliente.ordenes).forEach(function (key) {
              let orden = ordenesDeCliente.ordenes[key];
              orden.detalles.forEach(function (detalle) {
                if (detalle.descuento) {
                  cancelar = true;
                }
                requestPayload.ordenesDetalles.push(detalle.id);
              });
            });
          }

          requestPayload.giftcardId = self.localModel.payload.giftcard.id;
          requestPayload.ordenesCodigoAutorizacion = self.localModel.payload.ordenesCodigoAutorizacion;

          if (cancelar) {
            ngNotify.set('No se permiten descuentos en los detalles de orden', 'warn');
            return;
          }

          if (self.localModel.payload.giftcard.tipo.value == 'Monto') {
            $ngRedux.dispatch(rest.actions.canjearGiftcardMonto({ id: self.localModel.payload.giftcard.id }, {
              body: JSON.stringify(requestPayload)
            }, (err, data) => {
              if (!err) {
                ngNotify.set(self.translations['Comision con Giftcard de Monto procesada'], 'success');
                $state.go('home.facturas.list');
              } else if (err) {
                ngNotify.set(err.message, 'warn');
              }
            }));
          } else if (self.localModel.payload.giftcard.tipo.value == 'Gentileza') {
            $ngRedux.dispatch(rest.actions.canjearGiftcardGentileza({}, {
              body: JSON.stringify(requestPayload)
            }, (err, data) => {
              if (!err) {
                ngNotify.set(self.translations['Comision con Giftcard de Gentileza procesada'], 'success');
                $state.go('home.facturas.list');
              } else if (err) {
                ngNotify.set(err.message, 'warn');
              }
            }));
          }




        } else {
          self.model.descuento = self.localModel.payload.giftcard.montoRestante;
          self.model.giftcard = self.localModel.payload.giftcard;
          self.localModel.descuento = $filter('currency')(self.model.descuento, 'Gs.', 0);
        }
      }
    });
  }

  function newFormaPagoDescuento() {
    this.localModel.toggleFormaPagoDescuento = true;
    //this.model.formaPagoDescuento = this.localModel.formaPago.porcentajeDescuento;
  }

  function loadPaquetesNuevos(query) {
    let today = new Date();
    let filter = Filter.path('vigenciaInicio').lte(today)
      .and(Filter.path('vigenciaFin').gte(today))
      .and(Filter.path('estado.value').eq('Activo'));

    if (query) {
      filter = filter.and(Filter.path('codigo').like(query)
        .or(Filter.path('servicio.nombre').like(query))
        .or(Filter.path('codigo').like(query)));
    }

    BasicFactory.setup('paquetes');
    return BasicFactory.all({ filter: JSON.stringify(filter) });
  }

  this.filterPaquete = filterPaquete.bind(this);

  function filterPaquete(paqueteCliente) {
    return !this.localModel.paquetesClienteParciales[paqueteCliente.id];
  }

  this.deleteDetallePaquete = deleteDetallePaquete.bind(this);

  function deleteDetallePaquete(detalle) {
    delete this.localModel.paquetesCliente[detalle.id];
    if (detalle.id.startsWith('PA')) {
      delete this.localModel.paquetesClienteParciales[detalle.id.split('-')[1]];
    }
    this.updateTotales();
    //_.remove(this.model.detalles, detalle);
  }

  this.deleteDetalleGiftcard = deleteDetalleGiftcard.bind(this);

  function deleteDetalleGiftcard(detalle) {
    delete this.localModel.giftcards[detalle.id];
    this.updateTotales();
  }

  this.onSelectPaqueteNuevo = onSelectPaqueteNuevo.bind(this);

  function onSelectPaqueteNuevo() {
    this.localModel.payload.paquete = this.localModel.payload.meta.paqueteNuevo;
    this.localModel.payload.cantidad = this.localModel.payload.meta.paqueteNuevo.cantidadSesiones;
    this.localModel.payload.meta.sesionesMaximas = this.localModel.payload.cantidad;
  }

  this.onSelectPaqueteCliente = onSelectPaqueteCliente.bind(this);

  function onSelectPaqueteCliente() {
    this.localModel.payload.paquete = this.localModel.payload.meta.paqueteParcial.paquete;
    this.localModel.payload.cantidad = this.localModel.payload.meta.paqueteParcial.paquete.cantidadSesiones - this.localModel.payload.meta.paqueteParcial.cantidadSesionesPagadas;
    this.localModel.payload.meta.sesionesMaximas = this.localModel.payload.cantidad;
  }

  function loadPaquetesCliente(query) {
    let filter = Filter.path('estadoFacturacion.value').like('Saldo Pendiente');

    if (query) {
      filter = filter.and(Filter.path('paquete.codigo').like(query)
        .or(Filter.path('paquete.servicio.nombre').like(query))
        .or(Filter.path('paquete.codigo').like(query)));
    }

    BasicFactory.setup('paquetes-cliente');
    return BasicFactory.all({ filter: JSON.stringify(filter) });
  }

  function filterProducto(producto) {
    return producto.precio && !this.localModel.productos[producto.id];
  }

  function notEmpty(object) {
    return Object.keys(object).length;
  }

  function loadClientes(query) {
    if (!query) {
      return;
    }

    let filter = Filter.path('activo').eq(true);

    if (query) {
      filter = filter.and(Filter.path('nombre').like(query)
        .or(Filter.path('apellido').like(query))
        .or(Filter.path('razonSocial').like(query))
        .or(Filter.path('nombreFantasia').like(query))
        .or(Filter.path('numeroDocumento').like(query)));
    }

    BasicFactory.setup('clientes');

    return filter ? BasicFactory.all({ filter: JSON.stringify(filter) }) : BasicFactory.all();
  }

  function filterCliente(cliente) {
    return !this.localModel.ordenesPorCliente[cliente.id];
  }

  this.filterClienteSeleccionRapida = filterClienteSeleccionRapida.bind(this);

  function filterClienteSeleccionRapida(cliente) {
    let seleccionado = this.localModel.ordenesPorCliente[cliente.id];
    if (!seleccionado) {
      return moment(new Date()).format('DD/MM/YYYY') === cliente.fechaUltimaOrden;
    }
    return false;
  }

  this.cancel = cancel.bind(this);

  function cancel() {
    $state.go('home.facturas.list');
  }

  this.renderGiftcard = renderGiftcard.bind(this);


  function renderGiftcard(giftcard) {
    return `${giftcard.codigo} (${$filter('currency')(giftcard.montoRestante, 'Gs.', 0)}) ${giftcard.servicio ? ' - ' + giftcard.servicio.nombre : ''}`;
  }

  /**
   * Carga las giftcards que se pueden vender.
   * Trae giftcards:
   *  - Vigentes
   *  - Disponibles para la venta
   *  - De tipo Monto o De Servicio
   */
  this.loadGiftcardsVenta = loadGiftcardsVenta.bind(this);
  function loadGiftcardsVenta(query) {
    let today = new Date();

    let filterVigencia = Filter.path('vigenciaInicio').lte(today).and(Filter.path('vigenciaFin').gte(today));
    let filterEstado = Filter.path('estado.value').eq('Disponible Venta');
    let filterTipo = Filter.path('tipo.value').eq('Monto').or(Filter.path('tipo.value').eq('De Servicio'));

    let filter = filterVigencia.and(filterEstado).and(filterTipo);


    if (query) {
      filter = filter.and(Filter.path('codigo').like(query));
    }

    BasicFactory.setup('giftcards');
    return BasicFactory.all({ filter: JSON.stringify(filter) });
  }

  /**
   * Carga las giftcards que se pueden aplicar para descuento.
   * Trae giftcards:
   *  - Vigentes
   *  - Habilitadas o con Saldo Pendiente
   *  - De tipo Monto o Gentileza
   */
  this.loadGiftcardsDescuento = loadGiftcardsDescuento.bind(this);
  function loadGiftcardsDescuento(query) {
    let today = new Date();

    let filterVigencia = Filter.path('vigenciaInicio').lte(today).and(Filter.path('vigenciaFin').gte(today));
    let filterEstado = Filter.path('estado.value').eq('Habilitada').or(Filter.path('estado.value').eq('Saldo Pendiente'));
    let filterTipo = Filter.path('tipo.value').eq('Monto').or(Filter.path('tipo.value').eq('Gentileza'));

    let filter = filterVigencia.and(filterEstado).and(filterTipo);


    if (query) {
      filter = filter.and(Filter.path('codigo').like(query));
    }

    BasicFactory.setup('giftcards');
    return BasicFactory.all({ filter: JSON.stringify(filter) });
  }

  function onSelectFormaPago() {
    this.updateTotales();
  }

  this.filterGiftcardDescuento = filterGiftcardDescuento.bind(this);
  function filterGiftcardDescuento(giftcard) {
    // No se pueden aplicar giftcards de gentileza que no cubran toda la factura
    if (giftcard.tipo.value === 'Gentileza' && giftcard.montoRestante < this.model.total) {
      return false;
    }

    // Si la giftcard no tiene servicio, mostrar
    if (!giftcard.servicio)
      return true;

    // Si tiene servicio, debe existir al menos una ocurrencia de tal servicio en los detalles
    // de la factura para ser mostrado (almacenados en localModel.servicios).
    return Object.keys(this.localModel.servicios).includes(giftcard.servicio.id + "") && Object.keys(this.localModel.servicios).length === 1;
  }

  /**
   * Mantiene actualizada la lista de todas las ordenes
   */
  this.actualizarOrdenes = actualizarOrdenes.bind(this);
  function actualizarOrdenes() {
    let self = this;
    this.localModel.ordenes =
      Object.keys(this.localModel.ordenesPorCliente)
        .reduce(function (total, currentValue, currentIndex, arr) {
          return total.concat(Object.values(self.localModel.ordenesPorCliente[currentValue].ordenes))
        }, []);
  }

  /**
   * Recibe un array de  ordenes con producto.
   * Retorna true si algun producto tiene precio en Dolares, false caso contrario.
   */
  this.productosContienePrecioDolares = productosContienePrecioDolares.bind(this);
  function productosContienePrecioDolares(ordenesDetalles) {

    for (let ordenDetalle of ordenesDetalles) {
      if (!ordenDetalle.producto.precio) {
        ngNotify.set(`Producto ${ordenDetalle.producto.nombre} sin precio establecido`, 'warn');
        this.productosSinPrecio = ordenDetalle.orden.precio;
        return;
      }

      if (ordenDetalle.producto.precio.moneda.value === 'Dólares') {
        return true;
      }
    }
    return false;
  }

  /**
   * Recibe un array de ordenes detalle con servicio.
   * Retorna true si algun servicio tiene precio en Dolares, false caso contrario.
   */
  this.serviciosContienePrecioDolares = serviciosContienePrecioDolares.bind(this);
  function serviciosContienePrecioDolares(ordenesDetalles) {
    for (let ordenDetalle of ordenesDetalles) {
      if (ordenDetalle
        && ordenDetalle.servicio
        && ordenDetalle.servicio.precio
        && ordenDetalle.servicio.precio.moneda
        && ordenDetalle.servicio.precio.moneda.value === 'Dólares'
      ) {
        return true;
      }
    }
    return false;
  }

  this.updateRUC = updateRUC.bind(this);
  function updateRUC() {
    this.localModel.payload.nombre = this.localModel.payload.ruc.nombre;
    this.localModel.payload.apellido = this.localModel.payload.ruc.apellido;
    this.localModel.payload.numeroDocumento = this.localModel.payload.ruc.numero;
    this.localModel.payload.razonSocial = `${this.localModel.payload.nombre ? this.localModel.payload.nombre : ''} ${this.localModel.payload.apellido ? this.localModel.payload.apellido : ''}`;

    if (this.localModel.payload.ruc.personaFisica) {
      this.localModel.payload.tipoPersona = this.tiposPersona.filter((v) => v.value === 'Física')[0];
    } else {
      this.localModel.payload.tipoPersona = this.tiposPersona.filter((v) => v.value === 'Jurídica')[0];
      this.localModel.payload.razonSocial = this.localModel.payload.ruc.razonSocial;
    }
  }

  this.loadRUC = loadRUC.bind(this);
  function loadRUC(query) {
    let filter;

    if (query) {
      filter = Filter.path('nombre').like(query)
        .or(Filter.path('apellido').like(query))
        .or(Filter.path('razonSocial').like(query))
        .or(Filter.path('numero').like(query));
    }

    BasicFactory.setup('ruc');

    return filter ? BasicFactory.all({ filter: JSON.stringify(filter) }) : BasicFactory.all();
  }

  function buscar(parametro) {
    if (parametro) {
      return $ngRedux.dispatch(rest.actions.search({ parametro: parametro }));
    } else {
      return;
    }
  }

  this.renderRUC = renderRUC.bind(this);
  function renderRUC(ruc) {
    let numeroDoc = ruc.numero && ruc.digitoVerificador ? ruc.numero + "-" + ruc.digitoVerificador : 'Sin Nro. Documento';
    return `${ruc.razonSocial} <small><strong>(${numeroDoc})</strong></small>`;
  }

  this.checkFechaComprobanteRangoTimbrado = checkFechaComprobanteRangoTimbrado.bind(this);
  /**
   * Verifica si una fecha dada se encuentra dentro del rango de vigencia del timbrado seleccionado
   * @returns {boolean} true si la fecha esta dentro del rango del timbrado seleccionado, false caso contrario
   */
  function checkFechaComprobanteRangoTimbrado() {
    const fecha = this.model.fechaFactura && this.model.fechaFactura.getTime();
    const timbradoDesde = this.model.timbradoDetalle
      && this.model.timbradoDetalle.cabecera
      && this.model.timbradoDetalle.cabecera.desde;
    const timbradoHasta = this.model.timbradoDetalle
      && this.model.timbradoDetalle.cabecera
      && this.model.timbradoDetalle.cabecera.hasta;

    const enRango = fecha
      && timbradoDesde
      && timbradoHasta
      && fecha >= timbradoDesde
      && fecha <= timbradoHasta;

    if (!enRango) {
      ngNotify.set(this.translations['La fecha del comprobante está fuera de rango de vigencia del timbrado'], 'warn');
    }

    return enRango;
  }


}



// WEBPACK FOOTER //
// ./src/components/facturas/form/form.component.js